<template>
  <el-row
    :gutter="16"
    class="kpi-grid"
  >
    <el-col
      v-for="item in metrics"
      :key="item.key"
      :xs="12"
      :sm="8"
      :md="8"
      :lg="8"
      :xl="4"
    >
      <div class="kpi-card">
        <el-icon class="kpi-icon">
          <Icon :icon="item.icon" />
        </el-icon>
        <div class="kpi-content">
          <span class="kpi-value">{{ props.stats[item.key] || 0 }}</span>
          <span class="kpi-label">{{ item.label }}</span>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script setup>
import { defineProps } from 'vue'
import { Icon } from '@iconify/vue'
import feedbackIcon from '@iconify-icons/codicon/feedback'
import hubotIcon from '@iconify-icons/codicon/hubot'
import commentDiscussion from '@iconify-icons/codicon/comment-discussion'
import baselineOtherHouses from '@iconify-icons/ic/baseline-other-houses'
import roundSupportAgent from '@iconify-icons/ic/round-support-agent'
import baselinePeople from '@iconify-icons/ic/baseline-people'

const props = defineProps({
  stats: {
    type: Object,
    default: () => ({
      inQueueVisitors: 0,
      chattingVisitors: 0,
      totalVisitors: 0,
      loggedInAgent: 0,
      chattingAgent: 0,
      robotChattingVisitors: 0,
    }),
  },
})

const metrics = [
  { key: 'inQueueVisitors', label: 'In Queue Visitors', icon: baselinePeople },
  { key: 'chattingVisitors', label: 'Chatting Visitors', icon: commentDiscussion },
  { key: 'totalVisitors', label: 'Total Visitors', icon: baselineOtherHouses },
  { key: 'loggedInAgent', label: 'Logged In Agents', icon: roundSupportAgent },
  { key: 'chattingAgent', label: 'Chatting Agents', icon: feedbackIcon },
  { key: 'robotChattingVisitors', label: 'Robot Chatting Visitors', icon: hubotIcon },
]
</script>

<style scoped>
.kpi-grid {
  width: 100%;
}
.kpi-card {
  display: flex;
  align-items: center;
  gap: 14px;
  height: 100%;
  min-height: 96px;
  box-sizing: border-box;
  padding: 16px 18px;
  margin-bottom: 16px;
  border: 1px solid var(--el-border-color-lighter, #ebeef5);
  border-left: 3px solid var(--el-color-primary, #409eff);
  border-radius: 10px;
  background: var(--el-bg-color, #fff);
  transition: all 0.2s ease;
}
.kpi-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}
.kpi-icon {
  font-size: 2.2em;
  color: var(--el-color-primary, #409eff);
  flex-shrink: 0;
}
.kpi-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.kpi-value {
  font-size: 26px;
  font-weight: 600;
  line-height: 1.1;
  color: var(--el-text-color-primary, #303133);
}
.kpi-label {
  font-size: 13px;
  line-height: 1.3;
  min-height: 34px;
  color: var(--el-text-color-secondary, #909399);
  white-space: normal;
  word-break: break-word;
}
</style>
